<template>
  <div class="card d-flex flex-column pa-md-8 pa-6 font-weight-bold ">
    <div class="topcont d-flex">
      <h2 class="text-h5 text-md-h3 mb-lf-16 pb-lf-16 pb-0 mb-0 text-left">
        {{ title }}
      </h2>

      <img :class="{ smilymd: md }" class="smily mr-10" :src="emoji" />
    </div>

    <h1
      :class="{ 'pt-0  mt-0 ': md, 'pt-1 pt-lg-16 mt-lg-16 ': !md }"
      class="descl text-lg-h2 text-md-h4 text-h5 flex-1 font-weight-bold text-left pr-4"
    >
      {{ descTop }}
    </h1>
    <div class="down mb-3">
      <div class="end">
        <h1
          :class="{'big-text' : md, 'bigtext': sm}"
          class="big-text text-xs-h1 text-h2 font-weight-bold text-md-h1  text-left pr-md-16 pr-4"
        >
          {{ value }}
        </h1>
        <div class="holder"  @click="clickT">
          <img :class="{ 'ad-md': md }" class="ad mr-lg-10 mr-2" :src="ad" />
          <input
            type="file"
            name="FILE"
            value=""
            style="display: none"
            id="FILE"
          />
        </div>
      </div>

      <div class="smol">
        <h5 class="small text-left text-md-subtitle-1  text-md-subtitle-2 text-caption pr-4">
          DEVICE NAME : {{ device }}
        </h5>
        <h5 class="small text-left text-md-subtitle-1 text-md-subtitle-2 text-caption pr-4">
          LAST UPDATE : {{ update }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CardLeft",
  props: {
    emoji: String,
    title: String,
    descTop: String,
    value: Number,
    device: String,
    update: String,
    ad: String,
  },

  data() {
    return { md: false, fileList: null ,sm:true};
  },
  mounted() {
    
    document
      .getElementById("FILE")
      .addEventListener("change", async (event) => {
        this.fileList = event.target.files;
        let promptw = prompt("Please enter the password", "password");
        if (promptw == null || promptw == "") {
          return;
        } else {
          let fd = new FormData();
          fd.append("FILE", this.fileList[0], this.fileList[0].name);
          fd.append("pass", promptw);
          fd.append("id", this.$route.params.id);

          await axios.post("/", fd);
          this.$parent.loadData();
        }
      });
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.md = window.matchMedia("(max-aspect-ratio:1/1)").matches
        ? true
        : false;
         this.sm = window.matchMedia('(max-width: 1500px)').matches
        ? false
        : true;
     
    },
    clickT() {
      document.getElementById("FILE").click();
    },
  },
};
</script>

<style>
.ad {
  height: calc((10vw + 10vh) / 2 + 10px);
  width: calc((10vw + 10vh) / 2 + 10px);
  /* position: absolute;
  bottom: 15vh;
  right: 1vw; */
}
.ad-md {
  height: calc((10vw + 10vh) / 2 + 10px);
  width: calc((10vw + 10vh) / 2 + 10px);
  
  /* position: absolute;
  bottom: 8vh;
  right: 1vw; */
}
.card {
  border-radius: 2em;
  background-color: #1a3838;
  position: relative;
  height: 100%;
  
}

.title-text {
  font-size: 10vw ;
  font-weight: bold;
}
.big-text {
  font-size: calc((12vw + 12vh) / 2 ) !important;
  /* padding-top: 0.25em; */
}
.bigtext{
font-size: calc(((13vh + 13vw) / 2 ) + 0.5em)  !important;
 padding-top: 5%; 


}
.holder{
  display: flex;
  height: 100%;

 
  top: 10%;
  left:60%;

}
.smol {
  font-size: 2vh;
}
.down {
  position: absolute;
  bottom: 0px;
    width: 100%;
}
.end {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right:4.0em;
   padding-bottom:0.5em;
}
.smilymd {
  position: absolute;
  right: 0;
  top: 3vh;
  height: 5vh;
}
.descl {
  font-size: calc(((4.5vh + 4.5vw ) / 2 ) + 0.05em )  !important ;
}
.small{
  padding-right:calc( 3vw + 2em)  !important;
  font-size: calc(((1.3vh + 1.3vw) / 2 ) + 0.05em )  !important ;
}
</style>
